import { Modal } from '@/components/Modal/Modal'
import { strings } from '@/strings'

interface FollowConfirmModalProps {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => void
    handle: string
    displayName?: string
}

export function FollowConfirmModal({
    isOpen,
    onClose,
    onConfirm,
    handle,
    displayName,
}: FollowConfirmModalProps) {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={`Follow @${handle}?`}
            confirmLabel={strings.posts.followConfirmLabel}
            onConfirm={() => {
                onClose()
                onConfirm()
            }}
        >
            <p>
                You'll see posts from{' '}
                {/* eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- empty displayName should fall back to handle, not render blank */}
                <span className="font-semibold">{displayName || `@${handle}`}</span> in your
                timeline.
            </p>
        </Modal>
    )
}
